<template>
    <div class="settleInSuccess">
        <div class="successToast">
            <div class="success_icon">
                <i class="el-icon-success" style="font-size: 9.33rem;color: #23B423;"></i>
            </div>
            <div class="success_prompt">
                <div>提交成功，请保持电话畅通</div>
                <div>1-2个工作日会有客服人员联系您</div>
            </div>
            <div class="success_schedule_prompt">
                如要获悉实时审核进度
            </div>
            <div class="success_triangle">
                <i style="font-size: 2.8rem;color: #C5C5C5;" class="el-icon-caret-bottom"></i>
            </div>
            <div class="success_vrCode_block">
               <div>长按添加客服微信</div>
               <img src="../assets/WechatIMG38.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'settleInSuccess',
        components: {
        },
        data () {

            return {

            }
        },
        created(){
        },
        mounted() {
          document.title = "送水骑士 | 桶装水门店入驻";
        },
        methods:{

        }

    }
</script>
<style lang="less">
    .settleInSuccess{
        display: flex;
        flex-direction: column;
        align-items: center;
        .successToast{
            width: 70vw;
            border-radius: 1rem;
            background: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 14.6rem;
        }
        .success_header{
            display: flex;
            justify-content: end;
            width: 100%;
        }
        .success_icon{

        }
        .success_prompt{
            font-size: 3.4rem;
            text-align: center;
            margin-top: 2.8rem;
            line-height: 1.5;
            margin-bottom: 4.2rem;
        }
        .success_schedule_prompt{
            color: #999999;
            font-size: 2.7rem;
        }
        .success_triangle{
            margin-bottom: 1.9rem;
            font-size: 0;
        }
        .success_vrCode_block{
            width: 90%;
            padding: 1.9rem;
            //box-shadow: 0rem 1.5rem 2.8rem 0.1rem rgba(0,0,0,0.05);
            border-radius: 1rem;
            color: #444444;
            font-size: 3.4rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            img{
                width: 42rem;
                height: 42rem;
                margin-top: 3rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/settleInSuccess.vue